import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Row, Col } from '@thd-olt-component-react/grid';
import { Card } from '@thd-olt-component-react/card';
import { Heading } from '@thd-olt-component-react/heading';

const RelatedSearchProducts = (props) => {
  const {
    relatedSearchProducts,
    maxRelatedProducts,
    relatedProductTitle
  } = props;

  const {
    channel
  } = useContext(ExperienceContext);

  const relatedProductsToShow = [...relatedSearchProducts].slice(0, maxRelatedProducts);

  const handleMoreClick = (evt) => {
    evt.preventDefault();
    let currentProduct = $(evt.target).closest('.related-products__pod'); // eslint-disable-line no-undef
    currentProduct[0].className = 'related-products__pod col__12-12 largeView';
  };

  const handleCloseClick = (evt) => {
    evt.preventDefault();
    let currentProduct = $(evt.target).closest('.related-products__pod'); // eslint-disable-line no-undef
    currentProduct[0].className = 'related-products__pod col__3-12';
  };

  return (
    <Row id="related-products">
      {channel !== 'mobile' && (
        <Col>
          <Heading underline centered title={relatedProductTitle} />
          {(relatedProductsToShow || []).map((product, index) => {
            const { details, identifiers, media } = product || {};
            const { description } = details || {};
            const { canonicalUrl, productLabel } = identifiers || {};
            const { images } = media || {};
            const image = images?.[0];

            return (
              <div key={`relatedProduct-${image?.url}-${index}`} className="related-products__pod col__3-12">
                <div className="related-products__image">
                  <a href={canonicalUrl}>
                    {image?.url && (
                      <img
                        className="stretchy"
                        loading="lazy"
                        src={`${image?.url}`.replace(/<SIZE>/g, '600')}
                        alt={`${productLabel}`.replace(/"/g, '\'\'')}
                      />
                    )}
                  </a>
                </div>
                <div className="related-products__content">
                  <h3 className="related-products__title"> {productLabel} </h3>
                  <span
                    className="related-products__short-description"
                  >
                    {description.replace(/^(.{40}[^\s]*).*/, '$1')}
                  </span>
                  <span className="related-products__description">{description}</span>
                  <div>
                    <button className="related-products__more-link" type="button" href="#" onClick={handleMoreClick}>
                      <span className="related-products__more">More +</span>
                    </button>
                  </div>
                  <a className="related-products__product-details" href={canonicalUrl}>Product Details</a>
                  <button
                    className="related-products__largeView-close"
                    type="button"
                    href="#"
                    onClick={handleCloseClick}
                  >
                    <span>Close</span>
                    <i className="related-products__close" />
                  </button>
                </div>
              </div>
            );
          })}
        </Col>
      )}
      {channel === 'mobile' && (
        <Col>
          <Card noHide>
            <Card.Content title="Related Products" maxHeight="none">
              <div className="related-products__card">
                <Carousel>
                  {(relatedProductsToShow || []).map((product, index) => {
                    const { details, identifiers, media } = product || {};
                    const { description } = details || {};
                    const { canonicalUrl, productLabel } = identifiers || {};
                    const { images } = media || {};
                    const image = images?.[0];

                    return (
                      <div
                        key={`relatedProduct-${image?.url}-${index}`}
                        className="related-products__pod"
                      >
                        <div className="related-products__image">
                          <a href={canonicalUrl}>
                            {image?.url && (
                              <img
                                className="stretchy"
                                loading="lazy"
                                src={`${image?.url}`.replace(/<SIZE>/g, '600')}
                                alt={`${productLabel}`.replace(/"/g, '\'\'')}
                              />
                            )}
                          </a>
                        </div>
                        <div className="related-products__content">
                          <div className="related-products__title"> {productLabel} </div>
                        </div>
                      </div>
                    );
                  })}
                </Carousel>
              </div>
            </Card.Content>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export { RelatedSearchProducts };

RelatedSearchProducts.defaultProps = {
  maxRelatedProducts: 4,
  relatedProductTitle: 'Related Products',
  relatedSearchProducts: []
};

RelatedSearchProducts.propTypes = {
  maxRelatedProducts: PropTypes.number,
  relatedProductTitle: PropTypes.string,
  relatedSearchProducts: PropTypes.arrayOf(PropTypes.shape({}))
};
